// 等待页面DOM完全加载（确保目标元素存在）
document.addEventListener('DOMContentLoaded', function() {
    // 目标元素：展示预估送达日期的容器
    const deliveryDateElement = document.querySelector('.product-cell-info__value');
    
    // 检查元素是否存在（避免报错）
    if (!deliveryDateElement) {
        console.warn('未找到预估送达日期展示元素');
        return;
    }

    // 核心配置：洛杉矶时区（IANA标准时区标识符）
    const LA_TIMEZONE = 'America/Los_Angeles';
    
    // 1. 获取洛杉矶当前时间（修复时区处理逻辑，重置时分秒为00:00:00）
    const getLACurrentDate = () => {
        // 步骤1：获取当前时间的洛杉矶时区字符串（仅日期部分）
        const laDateStr = new Intl.DateTimeFormat('en-US', {
            timeZone: LA_TIMEZONE,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format();
        
        // 步骤2：将日期字符串转为Date对象，并重置时分秒为00:00:00（避免时间部分干扰日期计算）
        const laDate = new Date(laDateStr);
        laDate.setHours(0, 0, 0, 0);
        
        return laDate;
    };

    // 2. 日期计算：当前日期 + 指定天数（返回洛杉矶时区日期）
    const addDaysToLADate = (daysToAdd) => {
        const laDate = getLACurrentDate();
        // 计算目标日期（毫秒数运算，自动处理月份/年份切换）
        laDate.setDate(laDate.getDate() + daysToAdd);
        return laDate;
    };

    // 3. 日期格式化：转换为 "Tue,Nov.04" 格式（洛杉矶时区）
    const formatLADate = (laDate) => {
        // 星期缩写（如 Tue）
        const weekday = laDate.toLocaleDateString('en-US', {
            timeZone: LA_TIMEZONE,
            weekday: 'short'
        });
        // 月份缩写+日期（如 Nov.04）
        const monthDay = laDate.toLocaleDateString('en-US', {
            timeZone: LA_TIMEZONE,
            month: 'short',
            day: '2-digit'
        }).replace(' ', '.'); // 替换为 "Nov.04" 格式
        return `${weekday},${monthDay}`;
    };

    // 4. 生成预估送达日期范围（当前+6天 到 当前+9天）
    const generateDeliveryRange = () => {
        const startDate = addDaysToLADate(6);
        const endDate = addDaysToLADate(9);
        return `${formatLADate(startDate)} - ${formatLADate(endDate)}`;
    };

    // 5. 动态更新页面内容（确保初始值非空）
    const updateDeliveryDate = () => {
        const deliveryRange = generateDeliveryRange();
        if (deliveryRange) {
            deliveryDateElement.textContent = deliveryRange;
            console.log('洛杉矶时区预估送达日期更新成功：', deliveryRange);
        } else {
            // 降级处理：保留原有值（符合需求中"默认初始加载有值"的要求）
            console.warn('日期生成失败，保留原始内容');
        }
    };

    // 执行更新（页面加载时立即触发）
    updateDeliveryDate();

    // 可选：定时更新（如每24小时刷新一次，避免长时间停留页面导致日期过期）
    setInterval(updateDeliveryDate, 24 * 60 * 60 * 1000);
});
